import { loadable } from 'utils';

export const Basic = loadable(() => import('./Basic'), {});
export const Seller = loadable(() => import('./Seller'), {});
